import { render, staticRenderFns } from "./Footprints.vue?vue&type=template&id=4c646c66&lang=html&"
import script from "./Footprints.vue?vue&type=script&lang=js&"
export * from "./Footprints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports